import { Platform } from "@linkfluence/models/platform";
import { InfluencerAPI } from "@radarly/api/influencer";
import { InfluencerRepository } from "./InfluencerRepository";

interface Dependencies {
  influencerAPI: InfluencerAPI;
}

export class ConnectedInfluencerRepository implements InfluencerRepository {
  private influencerAPI: InfluencerAPI;
  constructor(dependencies: Dependencies) {
    this.influencerAPI = dependencies.influencerAPI;
  }
  public async getInfluencerFromUid(project: number, influencerId: string) {
    return await this.influencerAPI.getInfluencerFromUid(project, influencerId);
  }
  public async getInfluencer(project: number, platform: Platform, uid: string) {
    return await this.influencerAPI.getInfluencer(project, platform, uid);
  }
}
